import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5394077c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5394077c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394077c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5394077c')) {
      api.createRecord('5394077c', component.options)
    } else {
      api.reload('5394077c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5394077c&scoped=true&", function () {
      api.rerender('5394077c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/buyer/components/integral/index.vue"
export default component.exports